export default __webpack_public_path__ + "static/media/whatspp.cc50f3e2.svg";